import {CLOSE_RESULTS_PANEL, OPEN_RESULTS_PANEL, RESET_RESULTS_PANEL} from "../actions/action";
import {AnyAction} from "redux";

export const isResultsPanelOpen = state => state.resultsPanelOpen;

export function resultsPanelOpen(state: boolean = false, action: AnyAction) : boolean
{
    switch (action.type)
    {
        // case OPEN_RESULTS_PANEL:
        // {
        //     return true;
        // }
        //
        // case CLOSE_RESULTS_PANEL:
        // {
        //     return false;
        // }
        //
        // case RESET_RESULTS_PANEL:
        // {
        //     return null;
        // }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/results.ts